import { render, staticRenderFns } from "./InsightTopItems.vue?vue&type=template&id=6d0acb19&scoped=true&"
import script from "./InsightTopItems.vue?vue&type=script&lang=js&"
export * from "./InsightTopItems.vue?vue&type=script&lang=js&"
import style0 from "./InsightTopItems.vue?vue&type=style&index=0&id=6d0acb19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0acb19",
  null
  
)

export default component.exports